import { useQuery } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { ThreadListParams, ThreadListResponse } from './types'
import toast from 'react-hot-toast'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useThreads = (params: ThreadListParams = {}) => {
  const fetchWithAuth = useFetchWithAuth()

  const { filter = 'ALL', limit = 20, offset = 0, sort = 'newest' } = params

  return useQuery({
    queryKey: ['threads', { filter, limit, offset, sort }],
    queryFn: async () => {
      try {
        const queryParams = new URLSearchParams()
        queryParams.append('filter', filter)
        queryParams.append('limit', limit.toString())
        queryParams.append('offset', offset.toString())
        queryParams.append('sort', sort)

        const response = await fetchWithAuth(
          `${URL}/threads/?${queryParams.toString()}`
        )

        return response as ThreadListResponse
      } catch (error) {
        console.error('Error fetching threads:', error)
        toast.error('Unable to load messages. Please try again later.')
        throw error
      }
    },
    // Don't retry on server error to avoid spamming toast messages
    retry: (failureCount, error: any) => {
      if (error?.status === 500) return false
      return failureCount < 3
    },
  })
}
